module.exports = __webpack_public_path__ + "static/user-story-knowledge-gaming-market-v2-OberionIO.min-8f5423dc3e633f7a2f68ff5296e9e4cb.svg";